import qs from 'qs'
import Router from 'next/router'
import { useMemo, useState, useEffect } from 'react'
import { identity, isEqual } from 'lodash'

const generateURL = (parsedFilter) => {
  const queryString = qs.stringify(parsedFilter, { arrayFormat: 'brackets' })
  return `${window.location.pathname}${queryString.length ? `?${queryString}` : ''}`
}

const useQueryString = ({
  parser = identity,
  encoder = identity
}) => {
  const queryString = process.browser ? window.location.search.slice(1) : ''

  const initQueryParams = useMemo(() => parser(
    qs.parse(queryString)
  ), [queryString])

  const [filter, setFilter] = useState(initQueryParams)

  useEffect(() => {
    if (process.browser) {
      const href = generateURL(encoder(filter))
      if (Router.router.asPath !== href) {
        Router.replace(Router.router.pathname, href, { shallow: true })
      }
    }
  }, [filter])

  useEffect(() => {
    if (process.browser) {
      const derivedFilter = parser(qs.parse(queryString))

      if (!isEqual(derivedFilter, filter)) {
        setFilter(derivedFilter)
      }
    }
  }, [queryString])

  return [filter, setFilter]
}

export default useQueryString
